import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class AgentTypeSelectListCtrl implements IController {

  agentType: any;
  ngPlaceholder: any;
  onChange: Function;

  private queryString: string;
  private types: any;
  public permissions: any;

  /* @ngInject */
  constructor(private agentConstants) {
  }

  $onInit() {
    this.permissions = this.agentConstants.permissionsByType;
    this.types = _.map(this.agentConstants.types,(t) => {
      const permissionsRef = this.permissions[t];
      return {value: t, permission:  _.get(permissionsRef, 'update')}
    })
  }

  submitQuery(query) {
    this.queryString = query;
  }

}

angular
    .module('bringoz.admin.agents')
    .component('agentTypeSelectList', {
        bindings: {
          agentType: '<',
          ngPlaceholder: '@?',
          onChange: '&'
        },
        template: require('./agent-type-select-list.html').default,
        controller: AgentTypeSelectListCtrl
    });
